import { render, staticRenderFns } from "./CurrencyTableRow.vue?vue&type=template&id=4524a820&"
import script from "./CurrencyTableRow.vue?vue&type=script&lang=js&"
export * from "./CurrencyTableRow.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyTableRow.vue?vue&type=style&index=0&id=4524a820&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports